import Preferences from "./preferences";
import Abbreviation from "./abbreviation";
import Title from "./title";

const PhysicalExam = {
  Preferences,
  Abbreviation,
  Title,
};

export default PhysicalExam;
